/**
 * common — shared bilingual copy used across more than one view.
 *
 * View-specific strings live next to their component; only genuinely shared
 * copy (product name, nav, buttons, account, generic states) belongs here so
 * feature modules can `import { COMMON }` without editing each other's files.
 *
 * NOTE the product is deliberately named plainly ("Lunaria") — no "乙女/otome"
 * branding in any user-facing string.
 */
import type { Entry } from "./context.js";

export const COMMON = {
  // Product identity — neutral, genre-agnostic.
  appName: { zh: "Lunaria", en: "Lunaria" },
  appTagline: {
    zh: "用 AI 创作可玩的互动剧本",
    en: "Craft playable interactive stories with AI",
  },

  // Primary workspace tabs.
  tabStudio: { zh: "工作室", en: "Studio" },
  tabEditor: { zh: "卡片", en: "Cards" },
  tabCanvas: { zh: "画布", en: "Canvas" },
  tabAssets: { zh: "素材", en: "Assets" },
  tabPreview: { zh: "试玩", en: "Playtest" },

  // Nav / structure.
  episodes: { zh: "剧集", en: "Episodes" },
  noEpisodes: { zh: "还没有剧集", en: "No episodes yet" },

  // Books / projects.
  newBook: { zh: "新建作品", en: "New book" },
  adaptFromNovel: { zh: "从小说改编", en: "Adapt from a novel" },
  myFirstBook: { zh: "我的第一本书", en: "My first book" },
  newEpisode: { zh: "新建剧集", en: "New episode" },

  // Generic buttons.
  save: { zh: "保存", en: "Save" },
  cancel: { zh: "取消", en: "Cancel" },
  delete: { zh: "删除", en: "Delete" },
  confirm: { zh: "确定", en: "Confirm" },
  close: { zh: "关闭", en: "Close" },
  upload: { zh: "上传", en: "Upload" },
  download: { zh: "下载", en: "Download" },
  downloadProject: { zh: "下载作品包", en: "Download project" },
  generate: { zh: "生成", en: "Generate" },
  retry: { zh: "重试", en: "Retry" },
  back: { zh: "返回", en: "Back" },
  create: { zh: "创建", en: "Create" },
  start: { zh: "开始", en: "Start" },

  // Generic states.
  loading: { zh: "加载中…", en: "Loading…" },
  processing: { zh: "处理中…", en: "Working…" },
  generating: { zh: "正在生成…", en: "Generating…" },
  error: { zh: "出错了", en: "Something went wrong" },

  // Account / auth.
  guest: { zh: "访客", en: "Guest" },
  loggedIn: { zh: "已登录", en: "Signed in" },
  logout: { zh: "退出登录", en: "Sign out" },

  // Language toggle.
  language: { zh: "语言", en: "Language" },
} satisfies Record<string, Entry>;
